import React from 'react';
import blogCover from '../images/blog12.png';
import blogCover2 from '../images/blog16.png';
import OurPartner from '../pages/components/OurPartner';
import SuggestedBlogs from './components/SuggestedBlogs';

import { FaUser, FaCalendarAlt, FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { features } from "./components/BlogSection";
import { Link } from "react-router-dom";

const currentIndex = features.findIndex(
    (blog) => blog.link === "/cost-to-build-web-app-2026"
);

const prevBlog = features[currentIndex - 1];
const nextBlog = features[currentIndex + 1];

function CostToBuildWebApp2026() {

    const postDate = "March 4, 2026";

    return (
        <>
            {/* BLOG HEADER */}
            <section className="container my-5">

                <div className="text-center mb-4">

                    <h1 className="fw-bold responsive-heading mb-3">
                        <span className="highlight-orange">
                            Cost to Build a Web App in 2026 – Insights from Peregrinee
                        </span>
                    </h1>

                    <p className="mt-3 text-muted fs-5">
                        A detailed breakdown of web application development costs
                        in 2026 including features, tech stack, scalability,
                        maintenance, and long-term investment considerations.
                    </p>

                    {/* AUTHOR + DATE */}
                    <div className="d-flex justify-content-center align-items-center gap-4 mt-3 text-muted">

                        <span className="d-flex align-items-center gap-2">
                            <FaUser />
                            Posted by <strong>Peregrinee</strong>
                        </span>

                        <span className="d-flex align-items-center gap-2">
                            <FaCalendarAlt />
                            {postDate}
                        </span>

                    </div>

                </div>

            </section>


            {/* HERO IMAGE */}
            <section className="container mb-5">

                <img
                    src={blogCover}
                    alt="Web App Development Cost 2026"
                    className="img-fluid rounded-4 shadow w-100"
                    style={{ maxHeight: "500px", objectFit: "cover" }}
                />

            </section>


            {/* SECTION 1 */}
            <section className="container my-5 shadow-sm p-4 p-lg-5 rounded-4 bg-white">

                <div className="row align-items-center gy-4">

                    <div className="col-lg-6">

                        <img
                            src={blogCover}
                            alt="Web App Cost Factors"
                            className="img-fluid rounded-4 shadow-sm w-100"
                            style={{ objectFit: "cover", maxHeight: "420px" }}
                        />

                    </div>

                    <div className="col-lg-6">

                        <h3 className="fw-bold highlight-orange">
                            What Determines Web App Development Cost?
                        </h3>

                        <p>
                            The cost of building a web application in 2026
                            depends on several technical and strategic factors.
                            Each project differs in complexity, security,
                            integrations, and scalability requirements.
                        </p>

                        <h3 className="fw-bold highlight-orange mt-4">
                            Primary Cost Drivers
                        </h3>

                        <ul className="ps-3">
                            <li>Feature complexity and modules</li>
                            <li>Custom UI/UX design</li>
                            <li>Backend architecture and database design</li>
                            <li>Third-party integrations</li>
                            <li>Cloud infrastructure setup</li>
                            <li>Security compliance requirements</li>
                        </ul>

                        <p className="mt-3">
                            Understanding these components helps businesses
                            estimate budgets realistically.
                        </p>

                    </div>

                </div>

            </section>


            {/* SECTION 2 */}
            <section className="container my-5 shadow-sm p-4 p-lg-5 rounded-4 bg-white">

                <div className="row align-items-center gy-4">

                    <div className="col-lg-6 order-lg-1 order-2">

                        <h3 className="fw-bold highlight-orange">
                            Estimated Cost Ranges in 2026
                        </h3>

                        <p>
                            Based on industry trends and development experience,
                            here are approximate web application cost ranges:
                        </p>

                        <ul className="ps-3">
                            <li><strong>Basic MVP:</strong> $3,000 – $8,000</li>
                            <li><strong>Business Web App:</strong> $8,000 – $25,000</li>
                            <li><strong>Advanced SaaS Platform:</strong> $25,000 – $80,000+</li>
                            <li><strong>Enterprise System:</strong> $80,000 – $200,000+</li>
                        </ul>

                        <p className="mt-3">
                            Final costs depend on feature depth, automation,
                            analytics capabilities, scalability, and security.
                        </p>

                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold mt-3"
                            style={{ width: "fit-content" }}
                        >
                            Get a Custom Cost Estimate
                        </a>

                    </div>

                    <div className="col-lg-6 order-lg-2 order-1">

                        <img
                            src={blogCover2}
                            alt="Web App Pricing Strategy"
                            className="img-fluid rounded-4 shadow-sm w-100"
                            style={{ objectFit: "cover", maxHeight: "420px" }}
                        />

                    </div>

                </div>

            </section>


            {/* SECTION 3 */}
            <section className="container my-5 shadow-sm p-5 rounded-4 bg-white">

                <h2 className="fw-bold highlight-orange mb-4 text-center">
                    Detailed Cost Breakdown by Component
                </h2>

                <p>
                    A web application consists of multiple development layers,
                    each contributing to the final cost and quality.
                </p>

                <ul className="ps-3">
                    <li><strong>UI/UX Design:</strong> Wireframes and prototypes</li>
                    <li><strong>Frontend Development:</strong> Interactive user interface</li>
                    <li><strong>Backend Development:</strong> Server logic and APIs</li>
                    <li><strong>DevOps:</strong> Deployment and monitoring</li>
                    <li><strong>Security:</strong> Authentication and encryption</li>
                    <li><strong>Testing & QA:</strong> Performance and usability testing</li>
                </ul>

            </section>


            {/* SECTION 4 */}
            <section className="container my-5 shadow-sm p-5 rounded-4 bg-white">

                <h2 className="fw-bold highlight-orange mb-4 text-center">
                    Hidden Costs Businesses Often Overlook
                </h2>

                <ul className="ps-3">
                    <li>Cloud hosting costs</li>
                    <li>Third-party services and APIs</li>
                    <li>Maintenance and bug fixes</li>
                    <li>Future feature upgrades</li>
                    <li>Security monitoring and updates</li>
                </ul>

                <p className="mt-3">
                    Accounting for these ensures better long-term planning.
                </p>

            </section>


            {/* SECTION 5 */}
            <section className="container my-5 shadow-sm p-5 rounded-4 bg-white">

                <h2 className="fw-bold highlight-orange mb-4 text-center">
                    ROI Perspective: Investment vs Expense
                </h2>

                <p>
                    A web application is not merely a cost — it is a digital
                    asset that can automate operations, generate revenue,
                    and improve customer engagement.
                </p>

                <p>
                    Peregrinee focuses on building scalable applications
                    that deliver measurable ROI over time.
                </p>

                <div className="text-center mt-4">

                    <a
                        href="/contact-us"
                        className="btn btn-orange rounded-pill px-5 py-3 fw-bold"
                        style={{ width: "fit-content" }}
                    >
                        Discuss Your Project Budget Today
                    </a>

                </div>

            </section>


            {/* BLOG NAVIGATION */}
            <section className="container my-5">

                <div className="row">

                    {prevBlog && (
                        <div className="col-md-6 mb-3">

                            <Link
                                to={prevBlog.link}
                                className="d-flex align-items-center gap-3 p-3 border rounded-4 text-decoration-none blog-nav"
                            >

                                <FaArrowLeft />

                                <div>
                                    <small className="text-muted">Previous Blog</small>
                                    <h6 className="mb-0 fw-bold">{prevBlog.title}</h6>
                                </div>

                            </Link>

                        </div>
                    )}

                    {nextBlog && (
                        <div className="col-md-6 mb-3 text-md-end">

                            <Link
                                to={nextBlog.link}
                                className="d-flex align-items-center justify-content-md-end gap-3 p-3 border rounded-4 text-decoration-none blog-nav"
                            >

                                <div>
                                    <small className="text-muted">Next Blog</small>
                                    <h6 className="mb-0 fw-bold">{nextBlog.title}</h6>
                                </div>

                                <FaArrowRight />

                            </Link>

                        </div>
                    )}

                </div>

            </section>


            <SuggestedBlogs />

            <OurPartner />

        </>
    );
}

export default CostToBuildWebApp2026;